import { render } from "./PortfolioNavigationSection.vue?vue&type=template&id=0ad8ba39"
import script from "./PortfolioNavigationSection.vue?vue&type=script&lang=js"
export * from "./PortfolioNavigationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/PortfolioNavigationSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ad8ba39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ad8ba39', __exports__)) {
    api.reload('0ad8ba39', __exports__)
  }
  
  module.hot.accept("./PortfolioNavigationSection.vue?vue&type=template&id=0ad8ba39", () => {
    api.rerender('0ad8ba39', render)
  })

}


export default __exports__